<script lang="ts" setup>

  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()
  const { $cookie } = useNuxtApp()
</script>
<template>
  <div class="c-page-footer">
    <div class="section left">
      <div class="title">
        Contact
      </div>
      <NuxtLink
        to="?modal=faq"
        class="icon-link"
      >
        <SvgIcon
          icon="help"
          :height="20"
          :width="20"
        />
        <span class="link">Foire aux questions</span>
      </NuxtLink>
      <div class="icon-link">
        <SvgIcon
          icon="phone"
          :height="20"
          :width="20"
        />
        <a
          href="tel:0183625730"
          class="phone-number"
        >
          <span class="number">01&nbsp;83&nbsp;62&nbsp;57&nbsp;30</span><span class="caption">Prix d’un appel local</span>
        </a>
      </div>
      <span class="subtitle">Du lundi au vendredi de 9h00 à 17h00</span>
      <div class="icon-link">
        <SvgIcon
          icon="contact"
          :height="20"
          :width="20"
        />
        <a
          href="mailto:contact@bookandgolf.com"
          class="link"
        >contact@bookandgolf.com</a>
      </div>
    </div>

    <div
      v-if="!$config.public.isMobile"
      class="section center"
    >
      <div class="title">
        Bookandgolf
      </div>
      <NuxtLink
        to="/about-us"
        class="small-link"
      >
        {{ t("navigation.about") }}
      </NuxtLink>
      <NuxtLink
        to="?modal=contact&section=pro"
        class="small-link"
      >
        {{ t("navigation.pro-contact") }}
      </NuxtLink>
      <!-- <div class="social-links">
        <a
          href="https://www.instagram.com/bookandgolf"
          class="social-link"
          target="_blank"
        >
          <SvgIcon
            icon="instagram"
            :height="30"
            :width="30"
          />
        </a>
        <a
          href="https://fr-fr.facebook.com/bookandgolf/"
          class="social-link"
          target="_blank"
        >
          <SvgIcon
            icon="facebook"
            :height="30"
            :width="30"
          />
        </a>
      </div> -->
      <p class="cgv">
        <span>{{ t("footer.cgv") }}</span>
      </p>
    </div>
    <div class="section right">
      <div
        v-if="!$config.public.isMobile"
        class="top"
      >
        <AppLinks />
      </div>
      <div
        class="bottom"
        :class="{ mobile: $config.public.isMobile }"
      >
        <NuxtLink
          class="link"
          to="/privacy-policy"
        >
          {{ t("navigation.privacy-policy") }}
        </NuxtLink>
        <NuxtLink
          class="link"
          to="/legal-notice"
        >
          {{ t("navigation.legal-notice") }}
        </NuxtLink>
        <NuxtLink
          class="link"
          to="/cgv"
        >
          {{ t("navigation.terms-of-sales") }}
        </NuxtLink>
        <button
          type="button"
          class="cookie-button"
          @click="() => $cookie.showPreferences()"
        >
          Gestion des cookies
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped>

.c-page-footer {
  display: flex;
  flex: 1 0 auto;
  flex-wrap: wrap;
  justify-content: center;
  padding: 1.5rem 1.5rem 5rem;
  background-color: white;

  .title {
    display: flex;
    width: 100%;
    margin-top: 2rem;
    margin-bottom: 0.25rem;
    color: var(--color-secondary);
    font-family: Bariol, sans-serif;
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.29;
  }

  .icon-link {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 1rem;

    .c-icon {
      margin-right: 1rem;
      color: var(--color-secondary);
    }

    .link {
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 1.125rem;
      font-weight: 600;
      line-height: 1.33;
    }

    .phone-number {
      color: var(--color-primary);
      font-family: Bariol, sans-serif;
      font-size: 1.5rem;
      font-weight: 600;

      .number {
        letter-spacing: -1px;
      }

      .caption {
        margin-left: 0.25rem;
      }
    }
  }

  .subtitle,
  .caption {
    margin-left: 3em;
    color: var(--color-secondary);
    font-family: Open-Sans, sans-serif;
    font-size: 0.75rem;
    font-weight: 400;
    opacity: 0.6;
  }

  .small-link {
    display: flex;
    width: 50%;
    margin-top: 1.5rem;
    color: var(--color-secondary);
    font-family: Open-Sans, sans-serif;
    font-size: 0.875rem;
    font-weight: 600;
  }

  .section {
    display: flex;
    width: 100%;
    max-width: 20.25rem;

    &.left {
      display: flex;
      flex-direction: column;
    }

    &.center {
      display: flex;
      flex: 1 0 auto;
      flex-flow: row wrap;

      .social-links {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 1rem;
        cursor: pointer;

        .c-icon {
          width: 30px;
          height: 30px;
          margin-right: 1rem;
          color: var(--color-primary);
        }
      }

      .cgv {
        margin-top: 1em;

        span {
          color: var(--color-secondary);
          font-family: Open-Sans, sans-serif;
          font-size: 0.75rem;
          font-weight: 400;
        }
      }
    }

    &.right {
      display: flex;
      flex-direction: column;
      margin-top: 2rem;

      .top {
        display: flex;
        width: 100%;
        flex-flow: row wrap;
        justify-content: space-between;
      }

      .bottom {
        position: relative;
        display: flex;
        width: 100%;
        max-width: 100%;
        flex-wrap: wrap;
        justify-content: space-evenly;
        margin-top: 2rem;

        &.mobile {
          margin-top: 0;
        }

        .link, .cookie-button {
          margin: 0.5rem;
          color: var(--color-secondary);
          font-family: Open-Sans, sans-serif;
          font-size: 0.875rem;
          font-weight: 400;
          line-height: 1.36;
          opacity: 0.6;
          white-space: nowrap;
        }
      }
    }
  }

  @media screen and (width >= 1024px) {
    .title {
      height: 1.3em;
    }

    .small-link {
      min-width: 50%;
      height: 2em;
      min-height: 2em;
      align-items: center;
      margin-top: 1.5em;
    }

    .section {
      flex: 1 0;
    }

    .section.left {
      .icon-link {
        height: 2em;
        min-height: 2em;
      }
    }

    .section.center {
      margin-bottom: auto;

      .social-links {
        height: 2em;
        align-items: flex-start;
      }
    }
  }
}
</style>
